import { baseSeriesMark } from "../base/constant";

export const wordCloudSeriesMark = Object.assign(Object.assign({}, baseSeriesMark), {
    word: {
        name: "word",
        type: "text"
    },
    fillingWord: {
        name: "fillingWord",
        type: "text"
    },
    wordMask: {
        name: "wordMask",
        type: "rect"
    }
});
//# sourceMappingURL=constant.js.map
